import { render, staticRenderFns } from "./AppTopbarLinkGroupItem.vue?vue&type=template&id=26457394"
import script from "./AppTopbarLinkGroupItem.vue?vue&type=script&lang=js"
export * from "./AppTopbarLinkGroupItem.vue?vue&type=script&lang=js"
import style0 from "./AppTopbarLinkGroupItem.vue?vue&type=style&index=0&id=26457394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports